import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import BoxSection from '../Layout/BoxSection'

import { 
    displayModalAddReservacion, 
    addFile,
    updateInputs
} from '../../actions/solicitudhoteles'


import { 
    displayModalAddFile,
    downloadFile
} from '../../actions/common'


class Reservaciones extends Component {

	render() {
        
        const { id, solicitudhoteles } = this.props

        const estado = solicitudhoteles.get('estado')

        if (!id) return null

        const tipo_alojamiento = solicitudhoteles.getIn(['hotel', 'tipo_alojamiento'])
        
        return ( 
        <Fragment>

            <BoxSection title="Cierre de reservaciones">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-alojamientos">                                    
                    <thead>
                        <tr>
                            <th style={{ width: '25px', textAlign: 'center' }}>No.</th>
                            <th>Pasajero</th>
                            <th style={{ width: '10%' }}>No. Reservacion</th>
                            <th>Proveedor de alojamiento</th>
                            <th style={{ width: '70%' }}>Trayectos</th>                            
                        </tr>
                    </thead>
                    <tbody>
                    {
                        (solicitudhoteles.getIn(['hotel', 'huespedes']).count() > 0) &&
                            solicitudhoteles.getIn(['hotel', 'huespedes']).map((x, n) => {

                                const huesped = `${x.get('nombres')} ${x.get('apellidos')}`


                                //const hoy = new Date(2020, 11, 15)
                                const hoy = new Date() 

                                const expirados = x.getIn(['reservacion', 'rutas']).filter(i => moment(i.get('fecha_salida')) < moment(hoy))

                                return (                                        
                                    <tr key={ `tr[${n}]`}>
                                        <td className="text-right">{n+1}</td>
                                        <td>{ huesped }</td>
                                        <td>{x.getIn(['reservacion', 'numero_reservacion'])}</td>
                                        <td>{x.getIn(['reservacion', 'proveedor_alojamiento'])}</td>
                                        <td>
                                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-alojamientos">
                                                <thead>
                                                    <tr>
                                                        <th>Ciudad</th>
                                                        <th>Fecha ingreso</th>
                                                        <th>Fecha salida</th>
                                                        <th>¿Se cumplió con la estadía?</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        expirados.map((t,ti) => {
                                                            return(
                                                                <tr key={`ite[${n}][${ti}]`}>
                                                                    <td>{t.get('ciudad')}</td>
                                                                    <td>{ moment(t.get('fecha_ingreso')).format('DD/MM/YYYY') }</td>
                                                                    <td>{ moment(t.get('fecha_salida')).format('DD/MM/YYYY') }</td>
                                                                    {
                                                                        (estado < 7) ? (
                                                                            <td>
                                                                                <select className="form-control input-sm" value={ t.get('cumplido') == null ? "-1" : t.get('cumplido')  } onChange={ (e) => this.props.updateInputs(`solicitud.hotel.huespedes.${n}.reservacion.rutas.${ti}.cumplido`, e.target.value) } disabled={ estado != 6 } >
                                                                                    <option value="-1" disabled>Seleccione una opción</option>
                                                                                    <option value="0">No cumplió</option>
                                                                                    <option value="1">Si cumplió</option>
                                                                                </select>
                                                                            </td>
                                                                        ) : (
                                                                            <td>
                                                                            {
                                                                                `${t.get('cumplido') == 1 ? 'Si cumplió' : 'No cumplió'}`
                                                                            }
                                                                            </td>
                                                                        )
                                                                    }

                                                                    {
                                                                        (estado < 7) ? (
                                                                            <td>
                                                                                <textarea rows={2} cols={20} className="form-control input-sm" value={ t.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs(`solicitud.hotel.huespedes.${n}.reservacion.rutas.${ti}.observaciones`, e.target.value) } disabled={ estado != 6 } />
                                                                            </td>
                                                                        ) : (
                                                                            <td style={{height: '50px'}}>{ t.get('observaciones') }</td>
                                                                        )
                                                                    }                                                        

                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>                                                
                                            </table>                                                
                                        </td>  

  
                                    </tr>
                                )                                    
                            })
                    }   
                    </tbody>
                </table>

            
            </BoxSection>




        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudhoteles.get('id'),
        solicitudhoteles: state.solicitudhoteles.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddReservacion: (show, title, index) => dispatch(displayModalAddReservacion(show, title, index)), 
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reservaciones)


// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/Cierre.jsx